import VueRouter from 'vue-router'
import Vue from 'vue'
import SearchMain from '@/views/search/Main'

Vue.use(VueRouter)

const routes = [
    { path: '*', component: SearchMain }
  ]
  
const router = new VueRouter({
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
        return savedPosition
        } else {
        return { x: 0, y: 0 }
        }
    },
    routes
})

export default router;